import PropTypes from 'prop-types';
import React from 'react';

const PRINTER_PORTAL_PATH = '/printerportal';

const PrinterSetupTab = ({ hasNextTab, onSaveAndNext, onSaveStatus }) => {
  const handleYes = () => {
    if (onSaveStatus) {
      onSaveStatus({ isError: false, message: 'Printer setup confirmed.' });
    }
    if (hasNextTab && onSaveAndNext) {
      onSaveAndNext();
    }
  };

  const handleNo = () => {
    window.open(PRINTER_PORTAL_PATH, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="soa-printer-setup">
      <h3 className="soa-printer-setup-title">Printer Setup</h3>
      <p className="soa-printer-setup-question">
        Have you set up the printer for the store?
      </p>
      <div className="soa-printer-setup-actions">
        <button
          className="soa-printer-setup-yes-btn"
          type="button"
          onClick={handleYes}
        >
          Yes
        </button>
        <button
          className="soa-printer-setup-no-btn"
          type="button"
          onClick={handleNo}
        >
          No — Open Printer Portal
        </button>
      </div>
    </section>
  );
};

PrinterSetupTab.defaultProps = {
  hasNextTab: false,
  onSaveAndNext: null,
  onSaveStatus: null,
};

PrinterSetupTab.propTypes = {
  hasNextTab: PropTypes.bool,
  onSaveAndNext: PropTypes.func,
  onSaveStatus: PropTypes.func,
};

export default PrinterSetupTab;
